import React from "react";

import {pluralize} from "@pg-mono/string-utils";

interface IOfferDetailGeneratedDescriptionStorage {
    storage: {
        quantity: number;
        description: string;
        price: number;
    };
}

const storageQuantity = pluralize(["znajduje się", "znajdują się", "znajduje się"]);
const storageQuantityPlural = pluralize(["komórka lokatorska", "komórki lokatorskie", "komórek lokatorskich"]);

export const OfferDetailGeneratedDescriptionStorage = ({storage}: IOfferDetailGeneratedDescriptionStorage) => {
    if (!storage) {
        return null;
    }

    const descriptionSuffix = storage.description ? ` ${storage.description}${storage.description.trim().endsWith(".") ? "" : "."}` : ".";

    return (
        <p>
            {`W inwestycji ${
                storage.quantity
                    ? ` ${storageQuantity(storage.quantity)} ${storage.quantity} ${storageQuantityPlural(storage.quantity)}${descriptionSuffix}`
                    : `znajdują się komórki lokatorskie${descriptionSuffix}`
            }`}
        </p>
    );
};
import React from "react";

import {pluralize} from "@pg-mono/string-utils";

interface IOfferDetailGeneratedDescriptionStorage {
    storage: {
        quantity: number;
        description: string;
        price: number;
    };
}

const storageQuantity = pluralize(["znajduje się", "znajdują się", "znajduje się"]);
const storageQuantityPlural = pluralize(["komórka lokatorska", "komórki lokatorskie", "komórek lokatorskich"]);

export const OfferDetailGeneratedDescriptionStorage = ({storage}: IOfferDetailGeneratedDescriptionStorage) => {
    if (!storage) {
        return null;
    }

    const descriptionSuffix = storage.description ? ` ${storage.description}${storage.description.trim().endsWith(".") ? "" : "."}` : ".";

    return (
        <p>
            {`W inwestycji ${
                storage.quantity
                    ? ` ${storageQuantity(storage.quantity)} ${storage.quantity} ${storageQuantityPlural(storage.quantity)}${descriptionSuffix}`
                    : `znajdują się komórki lokatorskie${descriptionSuffix}`
            }`}
        </p>
    );
};
